import { createFeatureSelector, createSelector } from '@ngrx/store';

import { BrandingState } from '../branding.model';

export const getBrandingModuleState = createFeatureSelector<BrandingState>('brandingState');

/**
 * Select the name of the active tenant (e.g., 'Agravis', 'Agrifirm')
 */
export const getTenantName = createSelector(getBrandingModuleState, (state) => state.tenantName);
